import PublicHomeView from '@views/PublicHomeView.vue'
import { configureRouter } from "@/.shared/services/routing-services";
import Home from '@/views/AuthorizedHomeView.vue';
import { useAuthentication } from '@/.shared/services/auth';
import EmpresasAgentesView from '@/views/EmpresasAgentesView.vue';
import EmpresasServiciosView from '@/views/EmpresasServiciosView.vue';
import GestionEmpresaServiciosView from '@/views/GestionEmpresaServiciosView.vue';
import AnexoEmpresaServiciosView from '@/views/AnexoEmpresaServiciosView.vue';
import GestionEmpresaInmobiliariaView from '@/views/GestionEmpresaInmobiliariaView.vue';
import OperacionesEnergiaView from '@/views/OperacionesEnergiaView.vue';
import UsuariosView from '@/views/UsuariosView.vue';
import ClientesView from '@/views/ClientesView.vue';
import FacturasRecibidasView from '@/views/FacturasRecibidasView.vue';
import FacturasRectificativasView from '@/views/FacturasRectificativasView.vue';
import SoporteView from '@/views/SoporteView.vue';
import TicketView from '@/views/TicketView.vue';
import MarcosComisionesView from '@/views/MarcosComisionesView.vue';
import ContactosLeadView from '@/views/ContactosLeadView.vue';
import ComunicacionesOperacionView from '@/views/ComunicacionesOperacionView.vue';
import BorradoresOperacionEnergiaView from '@/views/BorradoresOperacionEnergiaView.vue';
import BorradoresOperacionAguaView from '@/views/BorradoresOperacionAguaView.vue';
import { usePermissionCheckers } from '@/services/auth/permission-checkers-bo';
import OperacionesAguaView from '@/views/OperacionesAguaView.vue';
import ImportacionesOperacionEnergiaView from '@/views/ImportacionesOperacionEnergiaView.vue';
import EmpresasAgentesPendientesValidacionView from '@/views/EmpresasAgentesPendientesValidacionView.vue';
import ComunicadosView from '@/views/ComunicadosView.vue';

export function configureAppRoutes() {
  configureRouter(router => {

    router.addRoute("home", b =>
      b
        .withPath("")
        .withComponent(PublicHomeView)
        .allowAnonymous()
        .configure(r => {
          r.beforeEnter = async (to, from, next) => {
            if (useAuthentication().isLoggedIn()) {
              return next({ name: "private-home" });
            }

            next();
          }
        }));


    router.addRoute("private-home", d => {
      d.withPath("home").withComponent(Home).withAuthorization({});
    });

    router.addRoute("empresas-servicios", d => {
      d.withPath("empresas-servicios/:tipoServicio").withComponent(EmpresasServiciosView).withAuthorization({authReqs: usePermissionCheckers().canAccessEmpresasServicios})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("empresas-servicios-gestionar", d => {
      d.withPath("empresas-servicios/:tipoServicio/:idEmpresaServicios").withComponent(GestionEmpresaServiciosView).withAuthorization({authReqs: usePermissionCheckers().canAccessEmpresasServicios})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("empresa-servicios-anexo", d => {
      d.withPath("empresas-servicios/:tipoServicio/:idEmpresaServicios/anexo").withComponent(AnexoEmpresaServiciosView).withAuthorization({ authReqs: usePermissionCheckers().canAccessEmpresasServicios })
        .configure(r => {
          r.props = route => {
            const q = route.query.id;
            const idRaw = q == null ? null : (Array.isArray(q) ? q[0] : q);
            const idAnexo = typeof idRaw === "string" && idRaw.length > 0 ? idRaw : null;
            return {
              tipoServicio: route.params.tipoServicio as string,
              idEmpresaServicios: route.params.idEmpresaServicios as string,
              idAnexo,
            };
          };
        });
    });

    router.addRoute("operaciones-energia", d => {
      d.withPath("operaciones/energia").withComponent(OperacionesEnergiaView).withAuthorization({authReqs: usePermissionCheckers().canAccessOperacionesEnergia})
        .configure(r => {
          r.props = route => ({
            mode: route.query.mode
          });
        });
    });

    router.addRoute("operaciones-agua", d => {
      d.withPath("operaciones/agua").withComponent(OperacionesAguaView).withAuthorization({authReqs: usePermissionCheckers().canAccessOperacionesEnergia})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("operaciones-importaciones", d => {
      d.withPath("operaciones/importaciones").withComponent(ImportacionesOperacionEnergiaView).withAuthorization({authReqs: usePermissionCheckers().canAccessImportacionesOperacionesEnergia});
    });

    router.addRoute("borradores-operacion-energia", d => {
      d.withPath("borradores-operacion/energia").withComponent(BorradoresOperacionEnergiaView).withAuthorization({authReqs: usePermissionCheckers().canAccessBorradoresOperacion})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("borradores-operacion-agua", d => {
      d.withPath("borradores-operacion/agua").withComponent(BorradoresOperacionAguaView).withAuthorization({authReqs: usePermissionCheckers().canAccessBorradoresOperacion})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("empresas-agentes", d => {
      d.withPath("empresas-agentes/:tipoEmpresaAgente").withComponent(EmpresasAgentesView).withAuthorization({authReqs: usePermissionCheckers().canAccessEmpresasAgentes})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("empresa-agentes", d => {
      d.withPath("empresa-agentes").withComponent(() => import('@/views/EmpresaAgentesView.vue'))
        .withAuthorization({})
        .configure(r => {
          r.props = route => ({
            idEmpresaAgentes: route.query.idEmpresaAgentes ?? null,
            tipoEmpresaAgente: route.query.tipoEmpresaAgente ?? null
          });
        });
    });

    router.addRoute("empresas-agentes-pendientes-validacion", d => {
      d.withPath("empresas-agentes/pendientes-validacion").withComponent(EmpresasAgentesPendientesValidacionView).withAuthorization({authReqs: usePermissionCheckers().canAccessEmpresasAgentes})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("empresas-inmobiliarias-gestionar", d => {
      d.withPath("empresas-inmobiliarias/:idEmpresaInmobiliaria").withComponent(GestionEmpresaInmobiliariaView).withAuthorization({authReqs: usePermissionCheckers().canAccessDelegacionesInmobiliarias})
        .configure(r => {
          r.props = true
        });
    });

    router.addRoute("usuarios", d => {
      d.withPath("usuarios").withComponent(UsuariosView).withAuthorization({authReqs: usePermissionCheckers().canAccessUsuarios});
    });

    router.addRoute("clientes", d => {
      d.withPath("clientes").withComponent(ClientesView).withAuthorization({authReqs: usePermissionCheckers().canAccessClientes});
    });

    router.addRoute("facturas", d => {
      d.withPath("facturas").withAuthorization({ authReqs: usePermissionCheckers().canAccessFacturas })
        .configure(r => r.redirect = "/facturas/colaboradores");
    });

    router.addRoute("facturas-colaboradores", d => {
      d.withPath("facturas/colaboradores").withComponent(FacturasRecibidasView).withAuthorization({authReqs: usePermissionCheckers().canAccessFacturas});
    });

    router.addRoute("facturas-processus", d => {
      d.withPath("facturas/processus").withComponent(FacturasRectificativasView).withAuthorization({authReqs: usePermissionCheckers().canAccessFacturas});
    });

    router.addRoute("soporte", d => {
      d.withPath("soporte").withComponent(SoporteView).withAuthorization({authReqs: usePermissionCheckers().canAccessSoporte});
    });

    router.addRoute("ticket", d => {
      d.withPath("ticket/:id?").withComponent(TicketView).withAuthorization({authReqs: usePermissionCheckers().canAccessSoporte})
        .configure(r => {
          r.props = true
        })
    });

    router.addRoute("marcos-comisiones", d => {
      d.withPath("marcos-comisiones").withComponent(MarcosComisionesView).withAuthorization({authReqs: usePermissionCheckers().canAccessMarcosComisiones});
    });

    router.addRoute("comunicaciones-operacion", d => {
      d.withPath("comunicaciones-operacion/:idOperacion/:codigoSecuencialOperacion/:tipoOperacion").withComponent(ComunicacionesOperacionView).withAuthorization({authReqs: usePermissionCheckers().canAccessOperacionesEnergia})
        .configure(r => {
          r.props = route => {
            const tipoOperacion = route.params.tipoOperacion;
            const tipoNormalizado = (tipoOperacion === "LUZ" || tipoOperacion === "GAS") ? "ENERGIA" : tipoOperacion;
            return {
              idOperacion: route.params.idOperacion ?? null,
              codigoSecuencialOperacion: route.params.codigoSecuencialOperacion ?? null,
              tipoOperacion: tipoNormalizado
            };
          };
        });
    });

    router.addRoute("nueva-venta", d => {
      d.withPath("nueva-venta")
        .withComponent(() => import('@/views/NuevaVentaEnergiaView.vue'))
        .withAuthorization({})
        .configure(r => {
    
          // Si no hay idOperacion ni idBorrador, redirigimos a la ruta de home
          r.beforeEnter = (to, from, next) => {
            const { id, idBorrador } = to.query;
    
            if (!id && !idBorrador) {
              return next({ name: "home" }); 
            }
    
            next();
          };
    
          r.props = route => ({
            id: route.query.id ?? null,
            idBorrador: route.query.idBorrador ?? null,
            idComparacion: route.query.idComparacion ?? null,
            idInmueble: route.query.idInmueble ?? null
          });
        });
    });

    router.addRoute("nueva-venta-agua", d => {
      d.withPath("nueva-venta-agua")
        .withComponent(() => import('@/views/NuevaVentaAguaView.vue'))
        .withAuthorization({})
        .configure(r => {
    
          // Si no hay idOperacion ni idBorrador, redirigimos a la ruta de home
          r.beforeEnter = (to, from, next) => {
            const { idOperacion, idBorrador } = to.query;
    
            if (!idOperacion && !idBorrador) {
              return next({ name: "home" }); 
            }
    
            next();
          };
    
          r.props = route => ({
            idOperacion: route.query.idOperacion ?? null,
            idBorrador: route.query.idBorrador ?? null
          });
        });
    });

    router.addRoute("tramite", d => {
      d.withPath("tramite").withComponent(() => import('@/views/TramiteView.vue'))
        .withAuthorization({})
        .configure(r => {
          r.props = route => ({
            idOperacion: route.query.idOperacion ?? null,
            tipoOperacion: route.query.tipoOperacion ?? null,
            idTramite: route.query.idTramite ?? null,
            tipoTramite: route.query.tipoTramite ?? null
          });
        });
    });
    
    router.addRoute("contactos-lead", d => {
      d.withPath("contactos-lead").withComponent(ContactosLeadView).withAuthorization({authReqs: usePermissionCheckers().canAccessContactosLead});
    });

    router.addRoute("comunicados", d => {
      d.withPath("comunicados").withComponent(ComunicadosView).withAuthorization({authReqs: usePermissionCheckers().canAccessComunicados});
    });
  });
}